module.exports = __webpack_public_path__ + "static/media/icon-15.67609aab.png";